import { gettext } from "web/script/modules/django-i18n";
import { MoreFiltersSection } from "web/types/universal-filters";

export const FILTER_SECTION = {
    genderFilter: "section-gender",
    saleFilter: "section-discount-from",
    brandFilter: "section-designer-slug",
    categoryFilter: "section-category",
    sizeFilter: "section-sizes",
    priceFilter: "section-final-price",
    colorFilter: "section-color",
    moreFilter: "section-more-filters",
    shippingFilter: "section-shipping",
    materialFilter: "section-material",
    retailerFilter: "section-retailer-slug",
} as const;

//  TODO: create this in BE
export const moreFiltersPill: MoreFiltersSection = {
    id: FILTER_SECTION.moreFilter,
    title: gettext("feed.filters.more_filters_title"), // More Filters
    type: null,
    all_option_names: "more_filters",
    option_groups: [
        {
            id: "option-group-more",
            title: null,
            type: "scroll_area",
            options: [],
        },
    ],
    active_filter_count: 0,
    should_render: true,
};
